import React from 'react';
import moment from 'moment';
import './index.scss';
import {  $http } from '../../lib/kbApp/kbJsBridgePromise';
import { detector } from '../../lib/util/Detect';
import { loadScript } from '../../lib/util/utils';
import { ugpageHost } from '../../const';

class Banners extends React.Component {
  constructor(props) {
    super(props);
    this.Log = this.props.Log;
    this.state = {
      bannerList: [],
    };
  }

  componentDidMount() {
    this.Log && this.Log.sendExposure({
      element_type: 'banner',
      element_name: 'banner_invite_help',
    });
    const queues = [this.getBannerList()];
    if (!window.Swiper) {
      queues.push(loadScript('//mat1.gtimg.com/www/js/kuaibao/lib/swiper-3.4.2.min.js'));
    }
    Promise.all(queues).then(() => {
      new window.Swiper('.banner-container', {
        spaceBetween: 20,
        autoplay: 3000,
        autoplayDisableOnInteraction: false,
      });
    });
  }

  getBannerList() {
    return $http.get(`${ugpageHost}/ugwelfare/api/content/welfareBanners`, {
      params: {
        appId: 0,
        bannerType: 1, // 任务banner 0，活动banner 1
      },
    }).then((res) => {
      if (res.code === 0 && res.data) {
        this.setState({
          bannerList: res.data.banners || [],
        });
      }
    });
  }

  handleClick(url) {
    if (!url) return;
    // if (detector.app.kuaibao) {
    //     openWebViewWithType(url)
    // } else {
    //     window.location.href = url
    // }
    window.location.href = url;
  }

  render() {
    const banners = this.state.bannerList
      .filter(item => moment(item.end_time) > moment() && moment(item.start_time) < moment());
    if (banners.length > 0) {
      return (
        <div className='banner-wrap'>
            <div className="banner-container">
                <div className="swiper-wrapper">
                    {
                        banners.map(item => (
                          <div
                            onClick={() => this.handleClick(item.go_url || '')}
                            className="swiper-slide" key={item.banner_id}
                            style={{ backgroundImage: `url(${item.icon_url || ''})` }}
                            log-click-eltype="banner"
                            log-click-elname={item.banner_id} >
                          </div>
                        ))
                    }
                </div>
            </div>
        </div>
      );
    }
    return (null);
  }
}

export default Banners;
